import { prisma } from "@/lib/db";
import { TagCreateForm, TagRow } from "./_form";

export const dynamic = "force-dynamic";

export default async function TagsAdminPage() {
  const tags = await prisma.tag.findMany({
    orderBy: { name: "asc" },
    select: {
      id: true,
      slug: true,
      name: true,
      _count: { select: { articles: true } },
    },
  });
  const items = tags.map((t) => ({
    id: t.id,
    slug: t.slug,
    name: t.name,
    articleCount: t._count.articles,
  }));

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-display text-2xl lg:text-3xl font-bold mb-1">Tags</h1>
        <p className="text-sm text-ink-muted">
          Tag dùng để phân loại bài theo chủ đề ngang nhau (ngoài chuyên mục). Một bài có thể có nhiều tag.
        </p>
      </div>

      <TagCreateForm />

      <div className="rounded-xl border border-stroke-subtle overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-bg-elevated/60 text-left">
            <tr className="border-b border-stroke-subtle">
              <th className="px-4 py-2.5 font-medium text-ink-muted">Tên</th>
              <th className="px-4 py-2.5 font-medium text-ink-muted">Slug</th>
              <th className="px-4 py-2.5 font-medium text-ink-muted">Bài</th>
              <th className="px-4 py-2.5 font-medium text-ink-muted text-right">Hành động</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-ink-muted text-sm">Chưa có tag nào.</td></tr>
            ) : items.map((t) => <TagRow key={t.id} t={t} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
